export default __webpack_public_path__ + "static/media/hn.bd26f8c8.png";